module.exports = __webpack_public_path__ + "img/w34b.1ba66598.jpg";